/* global $:false */

import tmpl_normal from '../templates/instance-field.dot';
import tmpl_option from '../templates/instance-field-option.dot';
import tmpl_references_container from '../templates/instance-field-references-container.dot';
import tmpl_textarea from '../templates/instance-field-textarea.dot';

import utils from '@cob/ui-genesis/cob.utils.js';

// args:
// * `core`: cob.app
// * `instance`: the json instance that the field belongs to
// * `field`: the json field
// * `fieldComponent`: an optional field component for special fields
//
// confs:
// * canEdit: If the user can edit the instance, otherwise all fields will be blocked
// * templateName: the name of the template to use. Defaults to 'tmpl-instance'.
//
// callbacks:
// * `clone`: The user requested a duplicate of this field
// * `removeDuplicate`: The user wants this duplicate removed
// * `dropField`: The user dropped another field on this (to re-order)
const FieldView = function(core, instance, field, fieldComponent, callbacks) {
    var _$element = {};
    var _$elementValueNode = {};

    var _externalHelpLoaded, _leftHelpPop;


    var _toggleButton = function() {
        /* eslint-disable-next-line no-invalid-this  */
        if ($(this).find(".icon-chevron-right").hasClass("icon-rotate-90")) {
            _colapseFields();
        } else {
            _expandFields();
        }
    };

    var _removeDuplicateButton = function() {
        callbacks.removeDuplicate(field.id);
    };

    var _expandFields = function() {

        // Don't show the children if there are no fields visible
        // because otherwise the border would be shown and it's ugly.
        if (_$element.find(".fields li:not(.hidden)").length > 0) {

            _$element.children(".fields").removeClass('hidden');
            //column fields (children of dualColumn) are never shown and it would not be possible to expand manually,
            // so we must expand their children as if they were direct children
            _$element.children(".fields").children("li.custom-column").children(".fields").removeClass('hidden');
        }

        _$element.children('table').find(".toggle-button .icon-chevron-right")
            .addClass("icon-rotate-90");

        // We need to add this trigger because when $text or $markdown fields
        // are in a collapsed block they have height 0 and they only
        // increase the height when the field is visible.
        $(window).trigger('resize');
    };

    var _colapseFields = function() {
        _$element.children(".fields").addClass('hidden');

        _$element.children('table').find(".toggle-button .icon-chevron-right")
            .removeClass("icon-rotate-90");
    };

    var _disableToggleButton = function() {
        _$element.children(".toggle-button").attr('disabled', 'true');
    };
    var _enableToggleButton = function() {
        _$element.children(".toggle-button").removeAttr('disabled');
    };

    var _getValue = function() {
        if (fieldComponent) {
            return fieldComponent.getValue();
        }

        return _$elementValueNode.val();
    };

    var _setValue = function(newValue) {
        if (fieldComponent) {
            fieldComponent.setValue(newValue);
        }

        _$elementValueNode.val(newValue);
    };

    var _buildPopoverOnce = function(helpDefName, helpDefFieldNames){
        if(!_externalHelpLoaded) {
            $.ajax({
                url: 'recordm/definitions/search/name/' + helpDefName,
                data: {
                    q: `${helpDefFieldNames[0]}:"${instance.jsonDefinition.name}" AND ${helpDefFieldNames[1]}:"${field.fieldDefinition.name}"`,
                    from: 0,
                    size: 1
                },
                contentType: 'application/json',
                success: function(data) {
                    _externalHelpLoaded = true;

                    $("a.js-help-" + field.fieldDefinition.id, _$element).popover({
                        html: true,
                        content: function() {
                            if(data.hits.total.value === 0){
                                return $("<div></div>")
                                    .append(core.translateString('recordm.instances', 'msgs.help-not-found'))
                                    .html();
                            }

                            return $("<div></div>")
                                .append(data.hits.hits[0]._source[helpDefFieldNames[2]][0])
                                .html();
                        },
                        title: function() {
                            return $("<div></div>").append(field.fieldDefinition.name).html();
                        },
                        container:'#'+core.getAppInstanceId(),
                        placement:"bottom",
                        trigger: "hover"

                    }).popover(_leftHelpPop ? 'hide': 'show'); //this second call shows the popover for the first time

                },
                error: function(error){
                    _externalHelpLoaded = true;

                    $("a.js-help-" + field.fieldDefinition.id, _$element).popover({
                        html: true,
                        content: function() {
                            return $("<div></div>").append(`Error ${error.status}: ${error.responseText}`).html();
                        },
                        title: function() {
                            return $("<div></div>").append(field.fieldDefinition.name).html();
                        },
                        container:'#'+core.getAppInstanceId(),
                        placement:"bottom",
                        trigger: "hover"

                    }).popover(_leftHelpPop ? 'hide': 'show'); //this second call shows the popover for the first time
                }
            });
        }
    };

    const makeDragAndDrop = function(scope){
       _$element.draggable({
          // where to attach the helper element, while it's being dragged
          appendTo: '#'+core.getAppInstanceId(),

          // does not return to the starting position after beeing dropped
          revert: 'invalid',

          // only start the drag if the mousedown is over this element
          handle: '.drag-handle',

          // limit interaction to same scope droppables
          scope: scope
       }).droppable({
          //class added to the element while something is beeing dragged
          activeClass: 'field-state-active',

          //class added to the elemente while something is hovering above it
          hoverClass: 'field-state-hover',

          // don't add the dropped element to parent droppables
          greedy: true,

          // limit interaction to same scope droggables
          scope: scope,

          // called when the element is actually dropped
          drop: function(_event, ui) {
             const _$draggedElement = ui.draggable;
             //para a li voltar à lista e não ficar com o offset do fim do drag
             _$draggedElement.attr('style', 'position:relative;');

             const draggedFieldId = _$draggedElement.data('instance-field-id');

             callbacks.dropField(draggedFieldId);
          }
       });
    };

    return{
        init: function(onChangeCb) {
            var isTextarea = field.fieldDefinition.text,
                isMarkdown = field.fieldDefinition.markdown,
                isReferencesList = field.fieldDefinition.references;

            field.dev = window.location.hostname === 'localhost' || RegExp('dev=(1|true)').test(window.location.search);
            if (isTextarea || isMarkdown) {
                field.htmlEncodedValue = utils.encodeHTML(field.value);
                _$element = $(tmpl_textarea(field));

            } else if (isReferencesList) {
                _$element = $(tmpl_references_container({
                    field: field
                }));

            } else {
                field.htmlEncodedValue = utils.encodeHTML(field.value);
                _$element = $(tmpl_normal(field));

                core.translate("recordm.instances", _$element);
            }

            _$element.data('instance-field-id', field.id);

            _$elementValueNode = _$element.find("#f" + field.id);
            _$elementValueNode.bind('keyup paste change', onChangeCb);

            if (isTextarea) {
                //resize inspirado em https://stackoverflow.com/q/454202
                _$elementValueNode.attr(
                    'style',
                    'height:' + (_$elementValueNode.scrollHeight) + 'px;overflow-y:hidden;'
                );
                _$elementValueNode.bind('input', function () {
                    /*eslint-disable no-invalid-this*/
                    this.style.height = 'auto';
                    this.style.height = (this.scrollHeight) + 'px';
                    /*eslint-enable no-invalid-this*/
                });
                $(window).on("resize",$.debounce(function (){_$elementValueNode.trigger("input")}, 50));

                _$elementValueNode.addClass("field-value cob-field-value");

            } else if (fieldComponent) {
                _$elementValueNode.replaceWith(fieldComponent.render());
                if(fieldComponent.afterRender) fieldComponent.afterRender(this);
            }

        },
        getContainer: function() {
            return _$element;
        },
        addChildField: function(fieldP) {
            _$element.children(".fields").append(fieldP.content());
        },
        addChildFieldAfter: function(fieldP, afterWhomP) {
            $(afterWhomP.content()).after(fieldP.content());
        },
        showToggleButton: function() {
            _$element.children("table").find(".toggle-button").removeClass('hidden').click(_toggleButton);
        },
        enableToggleButton: _enableToggleButton,
        disableToggleButton: _disableToggleButton,
        showDuplicateButton: function(scope) {
            _$element.children("table").find(".duplicate-button").removeClass('hidden').click(callbacks.clone);
            _$element.children("table").find(".drag-handle").removeClass('hidden');
            makeDragAndDrop(scope);
        },
        showRemoveButton: function(scope) {
            _$element.children("table").find(".remove-button").removeClass('hidden').click(_removeDuplicateButton);
            _$element.children("table").find(".drag-handle").removeClass('hidden');
            makeDragAndDrop(scope);
        },
        hideDuplicateButton: function() {
            _$element.children("table").find(".duplicate-button").addClass('hidden').off("click");
            _$element.children("table").find(".drag-handle").addClass('hidden');
            _$element.draggable('destroy').droppable('destroy');
        },
        hideRemoveButton: function() {
            _$element.children("table").find(".remove-button").addClass('hidden').off("click");
            _$element.children("table").find(".drag-handle").addClass('hidden');
            _$element.draggable('destroy').droppable('destroy');
        },
        expandFields: _expandFields,
        colapseFields: _colapseFields,
        hideSelf: function() {
            _$element.addClass('hidden');
        },
        showSelf: function() {
            _$element.removeClass('hidden');
        },
        enableSelf: function(){
            if (!fieldComponent) {
                if (_$elementValueNode[0] // porque os grupos nao tem valueNode
                    && (_$elementValueNode[0].tagName.toLowerCase() === 'input'
                        || _$elementValueNode[0].tagName.toLowerCase() === 'textarea')) {

                    _$elementValueNode.removeProp("readonly").removeAttr("tabindex");
                    _$elementValueNode.removeClass("disabled");
                } else {
                    _$elementValueNode.removeProp("disabled");
                }
            } else {
                if(typeof fieldComponent.enableSelf === 'function'){
                    fieldComponent.enableSelf();
                } else {
                    window.console.warn('Tried to enable a field component that does not support it. Field:', field.fieldDefinition.name )
                }
            }
        },
        disableSelf: function() {
            if (!fieldComponent) {
                if (_$elementValueNode[0] // porque os grupos nao tem valueNode
                    && (_$elementValueNode[0].tagName.toLowerCase() === 'input'
                    || _$elementValueNode[0].tagName.toLowerCase() === 'textarea')) {

                    _$elementValueNode.prop("readonly", true).attr("tabindex", -1);
                    _$elementValueNode.addClass("disabled");
                } else {
                    _$elementValueNode.prop("disabled", true);
                }
            } else {
               if(typeof fieldComponent.disableSelf === 'function'){
                  fieldComponent.disableSelf();
               } else {
                  window.console.warn('Tried to disable a field component that does not support it. Field:', field.fieldDefinition.name )
               }
            }
        },
        markRequiredError: function() {
            _$elementValueNode.addClass('error');
        },
        showError: function(error) {
            _$elementValueNode.addClass('error');

            // When errors are from recordm custom validators then we need to translate from a custom json file
            if (error.l10nSource && error.localizedMessage) {
                _$element.find(".field-errors").first()
                    .removeClass('hidden')
                    .html(`<span>${core.translateString(error.l10nSource, error.localizedMessage, "localresource/i18n", error.l10nArgs) || error.localizedMessage}</span>`);

            } else if(error.type || error.localizedMessage) {
                _$element.find(".field-errors").first()
                    .removeClass('hidden')
                    .html('<span rel="localize[error.' + (error.type||'').toLowerCase() + ']">' + (error.localizedMessage || 'error') + '</span>');

                core.translate('recordm.error.codes', '#instance-field-' + field.id);
            }
        },
        clearErrors: function() {
            _$element.removeClass('error');
            _$elementValueNode.removeClass('error');
            _$element.find(".field-errors").addClass('hidden').html('');
        },
        showOutdated: function(show){
            if(show){
               _$element.addClass('outdated-value');
               _$element.find('.outdated-indicator').attr(
                  'title',
                  core.translateString('recordm.instances', 'msgs.error-outdated')
               );
            } else _$element.removeClass('outdated-value')
        },
        getValue: _getValue,
        setValue: _setValue,
        remove: function() {
            _$element.remove();
        },
        showPasteButton: function(value, cb) {
            _$element.find('#paste-btn-' + field.id).removeClass('hidden')
                .attr('title', value).click(cb);
        },
        addOption: function(label, value) {
            var option = $(tmpl_option({label: label, value: value}));
            if (field.value === value) {
                option.attr('selected', 'true');
            }
            _$elementValueNode.append(
                option
            );
        },
        addHelpPopover: function(fieldDefId, helpText, fieldName) {
            if(helpText.startsWith('def:')){
                //todo lidar com campos e defs com [(),]
                const args = (/def:([^(]*)\(([^)]*)\)/).exec(helpText);
                const defName = args[1];
                const fields = args[2].toLowerCase().split(',').map((f) => f.trim().replace(' ', '_'));

                window.console.log(fieldName, 'external help kept at ', defName, 'fields', fields);
                $("a.js-help-" + fieldDefId, _$element)
                    .on('mouseenter', () => { _buildPopoverOnce(defName, fields) })
                    .on('mouseleave', () => { _leftHelpPop = true; })

            } else {
                $("a.js-help-" + fieldDefId, _$element).popover({
                    html: true,
                    content: function() {
                        return $("<div></div>").append(helpText).html();
                    },
                    title: function() {
                        return $("<div></div>").append(fieldName).html();
                    },
                    container:'#'+core.getAppInstanceId(),
                    placement:"bottom",
                    trigger: "hover"
                });
            }
        },
        setGroupFieldName : function(name){
            _$element.find('div.group-name:first').html(name);
        },
        markField: function() {
            _$element.addClass('marked');
        },
        unmarkField: function() {
            _$element.removeClass('marked');
        },
        blink: function(times){
            _$elementValueNode.effect("pulsate", { times:times }, 500);
        }
    }
};

export default FieldView;
